  <!-- ══ HERO ══ -->
  <section class="hero" id="hero" data-hero{{{ root }}}>
    <div class="hero-stage" data-stage>
      <figure class="hero-plate hero-plate--base" data-depth="0.012">
        <!-- sizes iki plakada da 112vw: ayrı değerler aynı kareyi iki kez indirtir -->
{{#if plate}}
        <img src="{{ plate }}" sizes="112vw" alt="" fetchpriority="high" decoding="async">
{{^}}
        <img src="assets/img/hero.jpg"
             srcset="assets/img/hero.jpg 1280w, assets/img/hero-1920.jpg 1920w, assets/img/hero-2560.jpg 2560w"
             sizes="112vw"
             alt="Siyah takım ve beyaz gömlek giyen model, brütalist bir merdiven boşluğunda kadraja bakıyor"
             width="1280" height="853" fetchpriority="high" decoding="async">
{{/if}}
      </figure>

      <!-- Aynı kare, renkli: imlecin çevresinde dairesel maskeyle açılır -->
      <figure class="hero-plate hero-plate--reveal" data-reveal aria-hidden="true">
{{#if plate}}
        <img src="{{ plate }}" sizes="112vw" alt="" decoding="async">
{{^}}
        <img src="assets/img/hero.jpg"
             srcset="assets/img/hero.jpg 1280w, assets/img/hero-1920.jpg 1920w, assets/img/hero-2560.jpg 2560w"
             sizes="112vw"
             alt="" width="1280" height="853" decoding="async">
{{/if}}
      </figure>

      <span class="hero-reticle" data-reticle aria-hidden="true"></span>
      <span class="hero-scrim" aria-hidden="true"></span>
      <span class="hero-grain" aria-hidden="true"></span>
      <span class="hero-vignette" aria-hidden="true"></span>
    </div>

    <div class="shell hero-content">
      <p class="eyebrow" data-tr-lang="en"{{{ eyebrow.attrs }}}>{{{ eyebrow.html }}}</p>

      <h1 class="hero-title"{{{ linesEdit }}}>
{{#each lines}}
        <span class="hero-line{{#if indent}} hero-line--indent{{/if}}" data-depth="{{ depth }}">
          <span class="swap"><span class="swap-a">{{{ upper }}}</span><span class="swap-b">{{{ text }}}</span></span>
{{#if amp}}
          <em class="hero-amp">&amp;</em>
{{/if}}
        </span>
{{/each}}
      </h1>

      <p class="hero-lede"{{{ lede.attrs }}}>{{{ lede.html }}}</p>

      <div class="hero-actions">
{{{ buttons }}}
      </div>
{{#if hint}}

      <p class="hero-hint">
        <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/></svg>
        <span{{{ hint.attrs }}}>{{{ hint.html }}}</span>
      </p>
{{/if}}
    </div>
  </section>

